
import { createSlice } from "@reduxjs/toolkit";
import { getVendor } from "../reduxApi/vendorReduxApi";

const vendorSlice = createSlice({
    name: 'vendor',
    initialState: {
        status: 'idel',
        vendor: [],
    },
    reducers: {
        deletevendorAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.vendor.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.vendor.splice(index, 1);
                }
            });
        },
        updatevendorAction: (state, action) => {
            console.log("action", action.payload.ROWID)
            const index = state.vendor.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.vendor.splice(index, 1, action.payload)
    
            }
        },
        addvendorAction: (state, action) => {
            console.log("Adding vendor:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.vendor.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getVendor.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getVendor.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing vendor Data", action.payload)
                state.vendor = action.payload.data.vendorResp
;
            })
    }
})
export const { deletevendorAction, updatevendorAction, addvendorAction } = vendorSlice.actions
export default vendorSlice.reducer